// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5m-6";
export var headerCell = "_5m-2";
export var rowWrapper = "_5m-4";
export var stickyAggregationCell = "_5m-a";
export var stickyAggregationRow = "_5m-7";
export var stickyColumnCell = "_5m-9";
export var stickyColumnHeaderCell = "_5m-8";
export var table = "_5m-1";
export var virtualRowWrapper = "_5m-5";
export var virtualTableContainer = "_5m-0";
export var white = "_5m-3";